// Add your custom JS here.

//import mapboxgl from 'mapbox-gl';
//import {fontAwesome} from '@fortawesome';
function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

jQuery(function($){

     window.currentMArkers = [];

    /*$('.map .legends input[type="checkbox"]').on('change', function(e){
        let el = $(this);
        console.log("event", e);
        let value = el.val();
        if(el.prop("checked")){
            $("."+value).show();
        }else{
            $("."+value).hide();
        }
        var cc = window.map.getContainer();
        var els = cc.getElementsByClassName('marker');
        var bounds = new mapboxgl.LngLatBounds();
        for (var i = 0; i < els.length; i++) {
            var ele = els.item(i);
            var elRect = ele.getBoundingClientRect();
            bounds.extend(elRect);
        }
        window.map.fitBounds(bounds);

    });*/
    $('body').on('click', "[data-confirm]", function (e){
        if(!confirm($(this).data("confirm")) ){
            return false;
        }else {
            return true;
        }
    });
    let  mapContainer = $("#map");
    if(mapContainer.length){
        mapboxgl.accessToken = wp_datas.cle_mapbox;

        let lat = mapContainer.data("lat");
        let lng = mapContainer.data("lng");
        let position = [];
        if(lat && lng){
            position = [lat, lng];
        }else{
            position = [1.1963011, 44.1319341] ;
        }


        const map = new mapboxgl.Map({
            container: 'map',
            //style: 'mapbox://styles/mapbox/streets-v11',
            style: 'mapbox://styles/periwinkle/clwubh7e301db01qr2z6g6hmh',
            center: position,
            zoom: mapContainer.data("zoom")?mapContainer.data("zoom") : 12,
            cooperativeGestures: true,
            scrollZoom: true
            //maxZoom: 15
        });
        const nav = new mapboxgl.NavigationControl();
        map.addControl(nav, 'top-right');

        map.on("wheel", event => {
            if (event.originalEvent.ctrlKey) {
                return;
            }
            if (event.originalEvent.metaKey) {
                return;
            }
            if (event.originalEvent.altKey) {
                return;
            }
            event.preventDefault();
        });

        map.on('drag ', event => {
            console.warn(event);
        });

        var bounds = new mapboxgl.LngLatBounds();
        window.map = map;
        window.bounds = bounds;
    }

    let currentMarkerPopup = null;
    let currentMarkerPopupSmall = null;
    function loadMarkersInner(map, features){
        let popup = new mapboxgl.Popup({
            offset: [0, -35],
            closeButton: true,
            closeOnClick: false
        });
        /*let popupSmall = new mapboxgl.Popup({
            offset: [0, -35],
            closeButton: false,
            closeOnClick: false
        });*/
        currentMarkerPopup = popup;
        //currentMarkerPopupSmall = popupSmall;

        for( let marker in window.currentMArkers){
            //console.log("Marker : "+marker, map._markers[marker])
            window.currentMArkers[marker].remove();
        }

        if(features.length > 0){
            var bounds = new mapboxgl.LngLatBounds();

            for( let i in features){
                //console.log(features[i]);
                let datas = features[i];

                //const marker = new mapboxgl.Marker({"color" : datas.properties['marker-color']}); // sans icône

                const marker = new FontawesomeMarker({
                    icon: datas.properties["icon"] ? "fa-solid "+datas.properties["icon"] :  'fa-solid fa-circle',
                    iconColor: '#ffffff',
                    color: datas.properties["marker-color"]
                }); // avec icône

                marker
                    .setLngLat(datas.geometry.coordinates)
                    //.setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(`<h3><a href="`+datas.properties['link']+`">`+datas.properties['title']+`</a></h3>`))
                    //.setPopup(new mapboxgl.Popup({ offset: 5 }).setHTML(datas.properties['allContent']))
                    .addTo(map);

                //elRect = new mapboxgl.LngLat(datas.geometry.coordinates.lng, datas.geometry.coordinates.lat)
                bounds.extend(datas.geometry.coordinates);
                let markerElement = marker.getElement();

                markerElement.addEventListener('mouseenter', (e) => {
                    map.getCanvas().style.cursor = 'pointer';
                    popup
                        .setLngLat(datas.geometry.coordinates)
                        .setHTML('<div class="marker-pop">'+datas.properties['title']+`</div>`)
                        //.setHTML(datas.properties['allContent'])
                        .addTo(map);
                    if(typeof popupCommune != "undefined"){
                        popupCommune.remove();
                    }
                    //console.log("mouseenter",e);
                });

                markerElement.addEventListener('mouseleave', (e) => {
                    //alert("mouseleave");
                    //console.log("mouseleave",e);
                    map.getCanvas().style.cursor = '';
                    //popup.remove();
                });

                markerElement.addEventListener('click', (e) => {
                    console.log("click", datas.geometry.coordinates );
                    let thumb = datas.properties['thumbnail'] ? '<div class="marker-pop"><img src="'+datas.properties['thumbnail']+'" class="img-fluig"></div>' : "";
                    //map.getCanvas().style.cursor = 'pointer';
                    popup
                        //.setLngLat(datas.geometry.coordinates)
                        .setHTML('<div class="marker-pop">'+thumb+`<h3>`+datas.properties['title']+`</h3>`+` <a href="`+datas.properties['link']+`" class="btn btn-primary btn-sm" target="_top">Plus d'infos</a></div>`)
                        //.setHTML('<div class="marker-pop">'+thumb+`<h3>`+datas.properties['title']+`</h3>`+`</div>`)
                        //.setHTML(datas.properties['title'])
                        .addTo(map);

                });

                /*markerElement.addEventListener('click', (e) => {
                    window.location.href = datas.properties['link'];
                    //console.log("mouseenter",e);
                });*/

                window.currentMArkers.push(marker);

            }
            if(features.length > 1){
                if($("#map").data("zoom") || $("#map").data("lat")){
                    // on ne fait rien
                }else{
                    // sinon on fit
                    map.fitBounds(bounds, {padding: 50});
                }

            }else{
                let datas = features[0];
                map.setCenter(datas.geometry.coordinates);
                map.setZoom(13)
            }

        }


        return;
        /*map.addSource('points', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': features
            }
        });*/

        // map.addLayer({
        //     'id': 'markers',
        //     'source': 'points',
        //     'type': 'symbol',
        //     //'type': 'circle',
        //
        //     /*"paint": {
        //         "circle-radius": 10,
        //         "circle-color": "#007cbf"
        //     },*/
        //     /*'paint': {
        //         'circle-color': '#4264fb',
        //         'circle-radius': 8,
        //         'circle-stroke-width': 2,
        //         'circle-stroke-color': '#ffffff'
        //     }*/
        //
        //     'layout': {
        //         /*"text-field": ['get', 'title'],
        //         "text-offset": [0, 0.6],*/
        //         "icon-image": "restaurant",
        //         "icon-size":1.5,
        //         "marker-size": "small",
        //         "marker-color": "#D90008"
        //     },
        //
        // });
        /*map.on('mouseenter', 'markers', function(e) {
            map.getCanvas().style.cursor = 'pointer';
            console.log('mouseenter', e);
        });
        map.on('mouseleave', 'markers', function(e) {
            map.getCanvas().style.cursor = 'auto';
            console.log('mouseleave', e);
        });*/
    }
    function loadMarkers(map, features){

        if(!map.isStyleLoaded()){
            map.on('load', function(e){

                loadMarkersInner(map, features);


            });
        }else{

            loadMarkersInner(map, features);
        }
    }


    function pwk_configureMarkers(){

        if($(".marker-data").length > 0){
            let features = [];
            $(".marker-data").each(function (i,e){
                var el = $(e);

                var color = el.data('color');
                var id = el.data('id');
                var lat = el.data('lat');
                var lng = el.data('lng');
                var type = el.data('type');
                var title = el.data('title');
                var link = el.data('link');
                var thumbnail = el.data('thumbnail');
                var icon = el.data('icon');
                var allContent = el.parents('.e-loop-item').html();
                /*let markerMap = new mapboxgl.Marker({color:color})
                    .setLngLat([lng, lat])
                    .addClassName(type)
                    .setPopup(new mapboxgl.Popup({ offset: 25, closeOnClick:false, closeButton:false, maxWidth:"200px" }).setHTML('<p><h3>'+title+'</h3></p>'))
                    .addTo(window.map);
                console.log("markerMap", markerMap);*/

                let feature = {
                    // feature for Mapbox DC
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            lng, lat
                        ]
                    },
                    'properties': {
                        'title': title,
                        'link': link,
                        'icon': icon,
                        "marker-color":color,
                        "id" : id,
                        "type" : type,
                        "thumbnail" : thumbnail,
                        "allContent" : allContent
                    }
                }
                features.push(feature);


                /*markerMap.on('hover', function(e){
                    console.log("Hover on ", e)
                })*/
                window.bounds.extend(new mapboxgl.LngLat(lng, lat));
            });

            loadMarkers(window.map, features);


        }





    }

    function customizeFilters(){
        $('.jet-filter-items-scroll [name="type_de_lieu"], .jet-filter-items-scroll [name="selection"]').each(function(i,e){
            let elt = $(e);
            let id = elt.val();
            let icon = "";
            let color = "";
            if(wp_datas.colorTypes[id] != undefined){
                color = wp_datas.colorTypes[id];
            }else{
               color = "#3D485F";
            }
            if(wp_datas.iconsTypes[id] != undefined){
                icon = "icon "+wp_datas.iconsTypes[id];
            }else{
                icon = "icon fa-solid fa-circle";
                icon = false;
            }

            elt.parent().find("span.icon").remove();
            if(icon){
                elt.parent().find(".jet-checkboxes-list__label").before(' <span class="icon '+icon+'" style="color:'+color+';"></span> ')
            }
        });
    }

    window.setTimeout(function(){
        pwk_configureMarkers();
        customizeFilters();
    }, 250);


    $( document ).on( 'jet-filter-content-rendered', function() {
        pwk_configureMarkers();
        customizeFilters();
    });


    var windowWidth = $(window).innerWidth();

    //console.log("tailles",elementorFrontend.config.responsive.breakpoints);
    if (elementorFrontend.config.responsive.breakpoints) {

        var windowMinWidth = elementorFrontend.config.responsive.breakpoints.tablet.value;
    } else {
        var windowMinWidth = 768;
    }
    var windowResponsiveMobile = windowWidth < windowMinWidth;
    function swapChildren(obj1, obj2) {
        var temp = obj2.children().detach();
        obj2.empty().append(obj1.children().detach());
        obj1.append(temp);
    }
    function toggleMobileStyles() {

        if (windowResponsiveMobile) {
            console.log('on passe le desktop en mobile');
            $("[id^='_desktop_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        } else {
            console.log('on passe mobile en desktop');
            $("[id^='_mobile_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        }
    }
    $(window).on('resize', function () {
        var _cw = windowWidth;
        var _mw = windowMinWidth;
        var _w = $(window).innerWidth();
        var _toggle = _cw >= _mw && _w < _mw || _cw < _mw && _w >= _mw;
        windowWidth = _w;
        windowResponsiveMobile = windowWidth < windowMinWidth;
        //console.log('_toggle', _toggle)
        if (_toggle) {
            toggleMobileStyles();
        }
    });

    $(document).ready(function () {
        if (windowResponsiveMobile) {
            toggleMobileStyles();
        }
    });



    let mapKlm = $(".containsKlm")
    if(mapKlm.length > 0){
        let featureCollection = {
            id : "communes",
            type: "FeatureCollection",
            features: []
        }

        mapKlm.find(".marker").each(function (i, e){
            let elt = $(e);
            let geojson = null;
            try{
                geojson = JSON.parse( JSON.stringify(elt.data("geojson")));

                //geojson.properties.id = elt.data('slug');
                geojson.properties.link = elt.data('link');

                console.log(geojson)
                window.toto = geojson;
            }catch(e){
                //alert(e.message);
                geojson = elt.data("geojson");
                //geojson.properties.id = elt.data('slug');
            }

            if(geojson){
                //
                featureCollection.features.push(geojson);
                console.log(JSON.stringify(featureCollection));
                window.toto = JSON.stringify(featureCollection);
            }



            const marker = new FontawesomeMarker({
                icon: elt.data("icon") ? "fa-solid "+elt.data("icon") :  'fa-solid fa-circle',

                iconColor: '#ffffff',
                color: elt.data("color") ? elt.data("color") : "#DB8749"
            }); // avec icône

            marker
                .setLngLat({
                    lat: elt.data("lat"),
                    lng: elt.data("lng")
                })
                //.setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(`<h3><a href="`+datas.properties['link']+`">`+datas.properties['title']+`</a></h3>`))
                //.setPopup(new mapboxgl.Popup({ offset: 5 }).setHTML(datas.properties['allContent']))
                .addTo(map);
        });


        let hoveredPolygonId = null;
        window.map.on('load', () => {
            window.map.addSource("communes", {
                'id' : "communesSrc",
                'type': 'geojson',
                'data': featureCollection,
                'generateId': true
            });
            window.map.addLayer({
                'id': "communes",
                'type': 'fill',
                'source': "communes", // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#DB8749', // blue color fill
                    //'fill-opacity': 0.25
                    'fill-opacity': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        0.25,
                        0.5
                    ]
                }
            });

            let popupCommune = new mapboxgl.Popup({
                    offset: [0, -5],
                    closeButton: false,
                    closeOnClick: false
                });
            map.on('mousemove', 'communes', (e) => {
                if (e.features.length > 0) {
                    if (hoveredPolygonId !== null) {
                        map.setFeatureState(
                            { source: 'communes', id: hoveredPolygonId },
                            { hover: false }
                        );
                        popupCommune.setHTML(e.features[0].properties.nom);
                        console.log(currentMarkerPopup.map);
                        if(currentMarkerPopup.map){
                            popupCommune.remove();
                        }else{
                            popupCommune.addTo(map);
                        }
                    }
                    popupCommune.setLngLat(e.lngLat);



                    map.getCanvas().style.cursor = 'pointer';
                    hoveredPolygonId = e.features[0].id;
                    map.setFeatureState(
                        { source: 'communes', id: hoveredPolygonId },
                        { hover: true }
                    );
                }
            });
            map.on('mouseleave', 'communes', () => {
                map.getCanvas().style.cursor = '';
                if (hoveredPolygonId !== null) {
                    popupCommune.remove();
                    map.setFeatureState(
                        { source: 'communes', id: hoveredPolygonId },
                        { hover: false }
                    );
                }
                hoveredPolygonId = null;
            });

            map.on('click', 'communes', (e) => {
                if (hoveredPolygonId !== null) {
                    window.toto = e.features[0];
                    window.location = e.features[0].properties.link;
                }
            });



        });

    } // fin

    $("#payfip_link").on("click", function(e){
        e.preventDefault();
        window.open($(this).attr("href"));

    });

    $(".galery-opener").on('click', function (e){
        e.preventDefault();
        //console.log("Click", $(".elementor-gallery__container a:first"))
        $(".elementor-gallery__container a:first").trigger("click");
    });


    document.addEventListener( 'jet-smart-filters/inited', function( initEvent ) {

        window.JetSmartFilters.events.subscribe("ajaxFilters/updated", (provider, queryId, response) => {
            console.log("ajaxFilters/updated");
            //$("#pwk_markers").html('');
            $("#map + #pwk_markers").remove();

            pwk_configureMarkers();
        } );


        window.JetSmartFilters.events.subscribe( "ajaxFilters/start-loading", (provider, queryID) => {
            $("#pwk_markers").remove();
        } );

    } );



});